import React from 'react';
import { motion } from 'framer-motion';
import { Settings, HeartPulse, Calendar } from 'lucide-react';
const features = [{
  icon: Settings,
  title: 'La Ingeniería de la Potencia',
  desc: "Cómo funciona tu 'bomba hidráulica' y cómo encenderla a voluntad, dominando tu fisiología."
}, {
  icon: HeartPulse,
  title: 'El Protocolo de Regeneración',
  desc: 'Nutrición y suplementos específicos para limpiar tus arterias y disparar tu Óxido Nítrico.'
}, {
  icon: Calendar,
  title: 'El Plan de 30 Días',
  desc: 'Qué hacer paso a paso para una transformación total. Sin conjeturas, solo resultados. Lograrás recuperar y mejorar tus erecciones.'
}];
export function SolutionSection() {
  return <section className="py-24 bg-brand-dark relative overflow-hidden" data-id="element-183">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-gold/5 rounded-full blur-[100px] pointer-events-none" data-id="element-184"></div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 relative z-10" data-id="element-185">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-186">
          <h2 className="font-serif text-5xl sm:text-6xl lg:text-7xl font-bold text-white mb-4" data-id="element-187">
            <span className="text-brand-gold" data-id="element-188">El Código Maestro</span>
          </h2>
          <p className="text-xl text-brand-text/90 max-w-2xl mx-auto font-medium" data-id="element-189">
            Te enseña como funciona tu sistema sexual desde adentro hacia afuera
            y como optimizarlo.
          </p>
          <p className="text-brand-muted mt-4 max-w-3xl mx-auto" data-id="element-190">
            Utilizando investigación científica, biohacking y nutrición
            avanzada.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 max-w-5xl mx-auto" data-id="element-191">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="flex flex-col items-center text-center gap-5 bg-brand-card/50 border border-brand-gold/10 p-6 sm:p-8 rounded-2xl hover:bg-brand-card hover:border-brand-gold/30 transition-all" data-id="element-192">
              <div className="flex-shrink-0" data-id="element-193">
                <div className="w-14 h-14 rounded-full bg-brand-gold/10 flex items-center justify-center border border-brand-gold/20" data-id="element-194">
                  <feature.icon className="w-7 h-7 text-brand-gold" data-id="element-195" />
                </div>
              </div>
              <div data-id="element-196">
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-197">
                  {feature.title}
                </h3>
                <p className="text-brand-muted leading-relaxed" data-id="element-198">
                  {feature.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}